/**
 * Mail Template Editor — Widget Blocks
 *
 * Each widget is a draggable GrapesJS block for the email editor.
 * HTML uses tables + inline styles for email client compatibility.
 */

export var WIDGET_CATEGORIES = {
  SECTIONS: 'Sections',
  CONTENU: 'Contenu',
  BOUTONS: 'Boutons',
  MISE_EN_FORME: 'Mise en forme',
  SOCIAL: 'Social',
}

export var widgets = [
  // ── SECTIONS ──────────────────────────────────────────────────────
  {
    id: 'widget-header',
    label: 'En-tête',
    category: WIDGET_CATEGORIES.SECTIONS,
    attributes: { class: 'bi bi-window' },
    content: '<table width="100%" cellpadding="0" cellspacing="0" style="background-color:#0091ca;padding:0;">\
      <tr>\
        <td style="padding:24px 40px;text-align:center;">\
          <h1 style="color:#ffffff;margin:0;font-family:\'Poppins\',Arial,sans-serif;font-size:22px;font-weight:600;">Votre Entreprise</h1>\
          <p style="color:rgba(255,255,255,0.8);margin:6px 0 0;font-family:\'Poppins\',Arial,sans-serif;font-size:13px;">Sous-titre ou slogan</p>\
        </td>\
      </tr>\
    </table>',
  },
  {
    id: 'widget-hero',
    label: 'Hero',
    category: WIDGET_CATEGORIES.SECTIONS,
    attributes: { class: 'bi bi-image' },
    content: '<table width="100%" cellpadding="0" cellspacing="0">\
      <tr>\
        <td style="padding:48px 40px;text-align:center;background-color:#f8f9fa;">\
          <h1 style="color:#333;font-family:\'Poppins\',Arial,sans-serif;font-size:28px;font-weight:700;margin:0 0 12px;">Titre principal</h1>\
          <p style="color:#666;font-family:\'Poppins\',Arial,sans-serif;font-size:16px;line-height:1.6;margin:0 0 24px;max-width:480px;display:inline-block;">Description courte de votre message.</p>\
          <table cellpadding="0" cellspacing="0" style="margin:0 auto;">\
            <tr>\
              <td style="background-color:#0091ca;border-radius:6px;">\
                <a href="#" style="display:inline-block;padding:14px 36px;color:#fff;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;font-weight:600;text-decoration:none;">Bouton d\'action</a>\
              </td>\
            </tr>\
          </table>\
        </td>\
      </tr>\
    </table>',
  },
  {
    id: 'widget-footer',
    label: 'Pied de page',
    category: WIDGET_CATEGORIES.SECTIONS,
    attributes: { class: 'bi bi-layout-text-window-reverse' },
    content: '<table width="100%" cellpadding="0" cellspacing="0" style="background-color:#333;">\
      <tr>\
        <td style="padding:24px 40px;text-align:center;">\
          <p style="color:rgba(255,255,255,0.6);font-family:\'Poppins\',Arial,sans-serif;font-size:12px;margin:0 0 8px;">\u00a9 2026 Votre Entreprise \u2014 Tous droits r\u00e9serv\u00e9s</p>\
          <p style="margin:0;">\
            <a href="#" style="color:rgba(255,255,255,0.8);font-size:12px;text-decoration:none;margin:0 8px;">Politique de confidentialit\u00e9</a>\
            <a href="#" style="color:rgba(255,255,255,0.8);font-size:12px;text-decoration:none;margin:0 8px;">Se d\u00e9sinscrire</a>\
          </p>\
        </td>\
      </tr>\
    </table>',
  },

  // ── CONTENU ───────────────────────────────────────────────────────
  {
    id: 'widget-text-block',
    label: 'Bloc texte',
    category: WIDGET_CATEGORIES.CONTENU,
    attributes: { class: 'bi bi-text-left' },
    content: '<table width="100%" cellpadding="0" cellspacing="0">\
      <tr>\
        <td style="padding:20px 0;">\
          <h2 style="color:#333;font-family:\'Poppins\',Arial,sans-serif;font-size:20px;font-weight:600;margin:0 0 12px;">Titre de section</h2>\
          <p style="color:#555;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;line-height:1.7;margin:0;">Votre texte ici.</p>\
        </td>\
      </tr>\
    </table>',
  },
  {
    id: 'widget-image-text',
    label: 'Image + Texte',
    category: WIDGET_CATEGORIES.CONTENU,
    attributes: { class: 'bi bi-layout-split' },
    content: '<table width="100%" cellpadding="0" cellspacing="0">\
      <tr>\
        <td width="40%" style="padding:16px;vertical-align:top;">\
          <img src="https://via.placeholder.com/240x160/e3f2fd/0091ca?text=Image" width="100%" style="border-radius:6px;display:block;" />\
        </td>\
        <td width="60%" style="padding:16px;vertical-align:top;">\
          <h3 style="color:#333;font-family:\'Poppins\',Arial,sans-serif;font-size:16px;font-weight:600;margin:0 0 8px;">Titre</h3>\
          <p style="color:#555;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;line-height:1.6;margin:0;">Description avec image \u00e0 gauche.</p>\
        </td>\
      </tr>\
    </table>',
  },
  {
    id: 'widget-info-box',
    label: 'Info box',
    category: WIDGET_CATEGORIES.CONTENU,
    attributes: { class: 'bi bi-info-circle' },
    content: '<div style="background:#f0f7ee;border-left:4px solid #0091ca;border-radius:0 6px 6px 0;padding:16px;margin:16px 0;">\
      <p style="margin:0 0 4px;color:#0091ca;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;font-weight:600;">Information importante</p>\
      <p style="margin:0;color:#555;font-family:\'Poppins\',Arial,sans-serif;font-size:13px;line-height:1.5;">D\u00e9tails de l\'information.</p>\
    </div>',
  },
  {
    id: 'widget-alert',
    label: 'Alerte',
    category: WIDGET_CATEGORIES.CONTENU,
    attributes: { class: 'bi bi-exclamation-triangle' },
    content: '<div style="background:#fff3e0;border-left:4px solid #e65100;border-radius:0 6px 6px 0;padding:16px;margin:16px 0;">\
      <p style="margin:0 0 4px;color:#e65100;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;font-weight:600;">\u26a0 Attention</p>\
      <p style="margin:0;color:#555;font-family:\'Poppins\',Arial,sans-serif;font-size:13px;line-height:1.5;">Message d\'alerte important.</p>\
    </div>',
  },
  {
    id: 'widget-success',
    label: 'Succ\u00e8s',
    category: WIDGET_CATEGORIES.CONTENU,
    attributes: { class: 'bi bi-check-circle' },
    content: '<div style="background:#e8f5e9;border-left:4px solid #2e7d32;border-radius:0 6px 6px 0;padding:16px;margin:16px 0;">\
      <p style="margin:0 0 4px;color:#2e7d32;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;font-weight:600;">\u2713 Succ\u00e8s</p>\
      <p style="margin:0;color:#555;font-family:\'Poppins\',Arial,sans-serif;font-size:13px;line-height:1.5;">Confirmation de l\'op\u00e9ration.</p>\
    </div>',
  },
  {
    id: 'widget-verification-code',
    label: 'Code v\u00e9rification',
    category: WIDGET_CATEGORIES.CONTENU,
    attributes: { class: 'bi bi-key' },
    content: '<table width="100%" cellpadding="0" cellspacing="0">\
      <tr>\
        <td align="center" style="padding:24px 0;">\
          <div style="display:inline-block;padding:16px 40px;background:#f8f9fa;border:2px dashed #0091ca;border-radius:8px;font-size:32px;font-weight:700;letter-spacing:8px;color:#0091ca;font-family:monospace;">000000</div>\
        </td>\
      </tr>\
    </table>',
  },
  {
    id: 'widget-data-table',
    label: 'Tableau de donn\u00e9es',
    category: WIDGET_CATEGORIES.CONTENU,
    attributes: { class: 'bi bi-table' },
    content: '<table width="100%" cellpadding="0" cellspacing="0" style="margin:16px 0;border:1px solid #e5e7eb;border-radius:6px;overflow:hidden;">\
      <tr style="background:#f8f9fa;">\
        <td style="padding:10px 16px;font-family:\'Poppins\',Arial,sans-serif;font-size:12px;font-weight:600;color:#6b7280;border-bottom:1px solid #e5e7eb;">Libell\u00e9</td>\
        <td style="padding:10px 16px;font-family:\'Poppins\',Arial,sans-serif;font-size:12px;font-weight:600;color:#6b7280;border-bottom:1px solid #e5e7eb;text-align:right;">Valeur</td>\
      </tr>\
      <tr>\
        <td style="padding:10px 16px;font-family:\'Poppins\',Arial,sans-serif;font-size:13px;color:#333;border-bottom:1px solid #f0f0f0;">\u00c9l\u00e9ment 1</td>\
        <td style="padding:10px 16px;font-family:\'Poppins\',Arial,sans-serif;font-size:13px;color:#333;text-align:right;border-bottom:1px solid #f0f0f0;">Valeur 1</td>\
      </tr>\
      <tr style="background:#f8f9fa;">\
        <td style="padding:10px 16px;font-family:\'Poppins\',Arial,sans-serif;font-size:13px;font-weight:600;color:#333;">Total</td>\
        <td style="padding:10px 16px;font-family:\'Poppins\',Arial,sans-serif;font-size:13px;font-weight:600;color:#333;text-align:right;">Total</td>\
      </tr>\
    </table>',
  },

  // ── BOUTONS ───────────────────────────────────────────────────────
  {
    id: 'widget-btn-primary',
    label: 'Bouton principal',
    category: WIDGET_CATEGORIES.BOUTONS,
    attributes: { class: 'bi bi-cursor' },
    content: '<table cellpadding="0" cellspacing="0" style="margin:24px 0;">\
      <tr>\
        <td style="background-color:#0091ca;border-radius:6px;">\
          <a href="#" style="display:inline-block;padding:14px 36px;color:#fff;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;font-weight:600;text-decoration:none;">Bouton d\'action</a>\
        </td>\
      </tr>\
    </table>',
  },
  {
    id: 'widget-btn-secondary',
    label: 'Bouton secondaire',
    category: WIDGET_CATEGORIES.BOUTONS,
    attributes: { class: 'bi bi-square' },
    content: '<table cellpadding="0" cellspacing="0" style="margin:24px 0;">\
      <tr>\
        <td style="border:2px solid #0091ca;border-radius:6px;">\
          <a href="#" style="display:inline-block;padding:12px 34px;color:#0091ca;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;font-weight:600;text-decoration:none;">Action secondaire</a>\
        </td>\
      </tr>\
    </table>',
  },
  {
    id: 'widget-btn-centered',
    label: 'Bouton centr\u00e9',
    category: WIDGET_CATEGORIES.BOUTONS,
    attributes: { class: 'bi bi-arrows' },
    content: '<table width="100%" cellpadding="0" cellspacing="0" style="margin:24px 0;">\
      <tr>\
        <td align="center">\
          <table cellpadding="0" cellspacing="0">\
            <tr>\
              <td style="background-color:#0091ca;border-radius:6px;">\
                <a href="#" style="display:inline-block;padding:14px 48px;color:#fff;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;font-weight:600;text-decoration:none;">Action principale</a>\
              </td>\
            </tr>\
          </table>\
        </td>\
      </tr>\
    </table>',
  },

  // ── MISE EN FORME ─────────────────────────────────────────────────
  {
    id: 'widget-divider',
    label: 'S\u00e9parateur',
    category: WIDGET_CATEGORIES.MISE_EN_FORME,
    attributes: { class: 'bi bi-dash-lg' },
    content: '<hr style="border:0;border-top:1px solid #e5e7eb;margin:24px 0;" />',
  },
  {
    id: 'widget-spacer-sm',
    label: 'Espace (petit)',
    category: WIDGET_CATEGORIES.MISE_EN_FORME,
    attributes: { class: 'bi bi-arrows-expand' },
    content: '<div style="height:16px;"></div>',
  },
  {
    id: 'widget-spacer-lg',
    label: 'Espace (grand)',
    category: WIDGET_CATEGORIES.MISE_EN_FORME,
    attributes: { class: 'bi bi-arrows-expand' },
    content: '<div style="height:40px;"></div>',
  },
  {
    id: 'widget-2col',
    label: '2 colonnes',
    category: WIDGET_CATEGORIES.MISE_EN_FORME,
    attributes: { class: 'bi bi-layout-split' },
    content: '<table width="100%" cellpadding="0" cellspacing="0">\
      <tr>\
        <td width="50%" style="padding:12px;vertical-align:top;">\
          <p style="color:#555;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;margin:0;">Colonne gauche</p>\
        </td>\
        <td width="50%" style="padding:12px;vertical-align:top;">\
          <p style="color:#555;font-family:\'Poppins\',Arial,sans-serif;font-size:14px;margin:0;">Colonne droite</p>\
        </td>\
      </tr>\
    </table>',
  },

  // ── SOCIAL ────────────────────────────────────────────────────────
  {
    id: 'widget-social',
    label: 'R\u00e9seaux sociaux',
    category: WIDGET_CATEGORIES.SOCIAL,
    attributes: { class: 'bi bi-share' },
    content: '<table width="100%" cellpadding="0" cellspacing="0" style="margin:16px 0;">\
      <tr>\
        <td align="center" style="padding:16px 0;">\
          <a href="#" style="display:inline-block;margin:0 6px;width:32px;height:32px;background:#3b5998;border-radius:50%;text-align:center;line-height:32px;color:#fff;font-size:14px;text-decoration:none;">f</a>\
          <a href="#" style="display:inline-block;margin:0 6px;width:32px;height:32px;background:#1da1f2;border-radius:50%;text-align:center;line-height:32px;color:#fff;font-size:14px;text-decoration:none;">t</a>\
          <a href="#" style="display:inline-block;margin:0 6px;width:32px;height:32px;background:#0077b5;border-radius:50%;text-align:center;line-height:32px;color:#fff;font-size:14px;text-decoration:none;">in</a>\
          <a href="#" style="display:inline-block;margin:0 6px;width:32px;height:32px;background:#e4405f;border-radius:50%;text-align:center;line-height:32px;color:#fff;font-size:14px;text-decoration:none;">ig</a>\
        </td>\
      </tr>\
    </table>',
  },
  {
    id: 'widget-unsubscribe',
    label: 'D\u00e9sinscription',
    category: WIDGET_CATEGORIES.SOCIAL,
    attributes: { class: 'bi bi-envelope-open' },
    content: '<table width="100%" cellpadding="0" cellspacing="0">\
      <tr>\
        <td style="padding:16px 0;text-align:center;">\
          <p style="color:#999;font-family:\'Poppins\',Arial,sans-serif;font-size:11px;margin:0;">\
            Vous recevez cet email car vous \u00eates inscrit sur notre plateforme.\
            <br />\
            <a href="#" style="color:#0091ca;text-decoration:underline;">Se d\u00e9sinscrire</a> \u00b7 <a href="#" style="color:#0091ca;text-decoration:underline;">Pr\u00e9f\u00e9rences</a>\
          </p>\
        </td>\
      </tr>\
    </table>',
  },
]

/**
 * Register all widget blocks in a GrapesJS BlockManager instance.
 */
export function registerWidgets(blockManager) {
  widgets.forEach(function (widget) {
    blockManager.add(widget.id, {
      label: widget.label,
      category: widget.category,
      content: widget.content,
      attributes: widget.attributes || {},
    })
  })
}
